
/**
 * Checks the condition and throws an error if it's false.
 *
 * @param condition
 * @param message
 *
 * @see http://stackoverflow.com/a/15313435/1397894
 */
export const assert = (condition, message) => {
  if (!condition) {
    message = message || 'Assertion failed';

    if (typeof Error !== 'undefined') {
      throw new Error(message);
    }

    throw message; // Fallback
  }
};

/**
 * Checks the index against the bounds of the array.
 *
 * @param index
 * @param array
 * @param message
 */
export const assertIndex = (index, array, message) => (
  assert(index >= 0 && index < array.length, message || `Index out of bounds: ${index}`)
);



// WEBPACK FOOTER //
// ./resources/assets/js/utils/assert.js